import { useCallback } from "react"
import { graphql } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import {
  ConcludeAppointmentInput,
  useConcludeAppointmentMutation as useConcludeAppointmentMutationType,
} from "@/modules/patients/services/__generated__/useConcludeAppointmentMutation.graphql"
import useCallContextStore from "@/stores/useCallContextStore"

const concludeAppointmentMutation = graphql`
  mutation useConcludeAppointmentMutation($input: ConcludeAppointmentInput!) {
    concludeAppointment(input: $input) {
      appointment {
        id
        status
        isCompleted
        completedAt
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useConcludeAppointmentMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useConcludeAppointmentMutationType>(concludeAppointmentMutation)

  const commitHandler = useCallback(
    (input: ConcludeAppointmentInput, onCompleted?: () => void) => {
      return new Promise<void>((res) => {
        commit({
          variables: {
            input: {
              id: input.id,
              agentFeedback: input.agentFeedback,
              collectBillingInput: input.collectBillingInput,
              shouldIncreaseMissedCall: input.shouldIncreaseMissedCall,
              inboundCallId: useCallContextStore.getState().inboundCallId,
            },
          },
          onCompleted() {
            onCompleted?.()
            res()
          },
        })
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}
